import { render, staticRenderFns } from "./SingleGoalRing.vue?vue&type=template&id=12aedade&scoped=true"
import script from "./SingleGoalRing.vue?vue&type=script&lang=js"
export * from "./SingleGoalRing.vue?vue&type=script&lang=js"
import style0 from "./SingleGoalRing.vue?vue&type=style&index=0&id=12aedade&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aedade",
  null
  
)

export default component.exports